// POPUP_TYPES
export const ASK_POPUP_TYPE = "ask";
export const WARNING_POPUP_TYPE = "warning";
export const SUCCESS_POPUP_TYPE = "success";
export const ATTENTION_POPUP_TYPE = "attention";
export const ERROR_POPUP_TYPE = "error";
